module.exports = __webpack_public_path__ + "files/446fc32a61a777df3576fc8c3dbd135d.png";